<template>
  <Layout
    :errors="errors"
    :title="trans(`models.${resourceType}.content.show.action`)"
    :toasts="toasts"
    :resource="model"
  >
    <slot name="top" />
    <card v-if="model.data" class="resource-action-box mb-3"
          :key="model.data.id"
          :title="trans(`models.${resourceType}.content.show.action`)"
    >
      <div class="model-title-bar d-flex justify-content-between">
        <p v-if="localModel.data.id" class="card-text">
          {{ trans(`models.${resourceType}.content.show.description`) }}
        </p>
        <div class="row pe-2">
          <resource-action-buttons
            :button-class="'btn btn-primary text-secondary'"
            :model="model"
            :resource-type="resourceType"
            :source-action="'show'"
          ></resource-action-buttons>
        </div>
      </div>
    </card>
    <div class="row mb-2">
      <div
        v-for="(groups, section) in model.presentation.sections"
        :key="section"
        :class="'col-' + (section === 'core_data' || section === 'meta_data' ? '6' : '12')"
      >
        <div v-for="(columns, group) in groups" :key="group" :class="Object.keys(columns).length > 0 ? '' : 'd-none'">
          <element-collection
            v-if="section !== 'has_many_relation_data' && section !== 'media_data'"
            :columns="columns"
            :field-group="group"
            :model="model"
          ></element-collection>
          <div v-if="section === 'has_many_relation_data'">
            <card
              v-for="(relatedKey, name) in columns"
              :key="name"
              :title="trans('models.' + resourceType + '.relations.' + name)"
              :options="{ style: { card: 'margin-bottom: 1rem;' } }"
            >
              <resource-collection
                :collection-type="model.data.collections[name].meta.config.component?.type ?? 'list'"
                :foreign-name="name"
                :mode="'component'"
                :models="model.data.collections[name]"
                :name="name"
                :parent-model="model"
                :parent-resource="resourceType"
              ></resource-collection>
            </card>
          </div>
          <div v-if="section === 'media_data' && model.data.media">
            <template v-for="(media, name) in columns">
              <card
                v-if="model.data.media[name]"
                :key="name"
                :title="trans('models.' + resourceType + '.attributes.' + name)"
                :options="{ style: { card: 'margin-bottom: 1rem;' } }"
              >
                <media-collection :media="model.data.media[name]"></media-collection>
              </card>
            </template>
          </div>
        </div>
      </div>
    </div>
    <slot name="bottom" />
  </Layout>
</template>

<script>
import Card from '@/structures/default/components/Base/Card';
import ElementCollection from '@/structures/default/components/Presentation/ElementCollection.vue';
import MediaCollection from '@/structures/default/components/Presentation/MediaCollection.vue';
import Layout from '@/structures/moviary/Pages/Layout';
import ResourceActionButtons from '@/structures/default/components/Links/ResourceActionButtons';
import ResourceCollection from '@/structures/default/components/ResourceCollection';
import { ref } from 'vue';
import useResource from '@/structures/default/composables/useResource';

export default {
  components: {
    Card,
    ElementCollection,
    Layout,
    MediaCollection,
    ResourceActionButtons,
    ResourceCollection,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    logEntries: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  emits: ['addToast'],
  setup(props) {
    const localModel = ref(props.model);
    const { meta, resourceType } = useResource(props, props.model);

    return {
      localModel,
      meta,
      resourceType,
    };
  },
};
</script>
